// Stable per-user colour for cursors, selections and avatars.
// Deterministic on the user id so every participant sees the same colour for
// the same person, without any coordination.

const PALETTE = [
	'#e5484d', // red
	'#0091ff', // blue
	'#30a46c', // green
	'#f76b15', // orange
	'#8e4ec6', // purple
	'#0d9488', // teal
	'#d6409f', // pink
	'#a18072', // brown
	'#0588f0', // sky
	'#bdaa22', // olive
]

export function userColor(userId: string) {
	let hash = 0
	const id = String(userId ?? '')
	for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) | 0
	return PALETTE[Math.abs(hash) % PALETTE.length]
}

export function initials(name: string) {
	const parts = String(name ?? '').trim().split(/\s+/).filter(Boolean)
	if (!parts.length) return '?'
	if (parts.length == 1) return parts[0].slice(0, 2).toUpperCase()
	return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
